var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patient-view record"},[_c('FileCard',{attrs:{"patient":_vm.patient}}),_c('RecordCard',{attrs:{"patient":_vm.patient}}),_c('SurveyCard',{attrs:{"patient":_vm.patient,"is-survey":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }